<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="$t('changeRequestApproval.approveModal.title')"
    @hide="onDialogHide"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ $t('changeRequestApproval.approveModal.text', {approvalRequestsAmount}) }}
      </p>
      <div
        v-if="hasRejectedChangeRequest"
        class="col-12"
      >
        <hr-warning-banner
          :message="$t('changeRequestApproval.approveModal.warning')"
        />
      </div>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        :label="$t('common.buttonConfirm')"
        @click="onConfirm"
      />
    </template>
  </hr-form-dialog>
</template>
<script>
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
  HrWarningBanner,
} from 'src/design-system';

export default {
  name: 'ChangeRequestConfirmationModal',

  components: {
    HrConfirmBtn,
    HrDismissBtn,
    HrFormDialog,
    HrWarningBanner,
  },

  props: {
    approvalRequestsAmount: {
      type: Number,
      required: true,
    },
    hasRejectedChangeRequest: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['hide', 'ok'],

  methods: {
    show() {
      this.$refs.dialog.show();
    }, // show()

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    async onDialogHide() {
      this.$emit('hide');
    }, // onDialogHide()

    async onConfirm() {
      this.$emit('ok');
      this.hide();
    }, // onConfirm()

  },
};
</script>
